import React from 'react'
import {Document, Page, View} from "@react-pdf/renderer"

import {baseStyles} from "../../styles"
import {AmountDueAtSigningPDF} from "../../components/AmountDueAtSigningPDF"
import {PaymentInformationPDF} from "../../components/PaymentInformationPDF"
import {TaxInformationPDF} from "../../components/TaxInformationPDF"
import {FeeBreakdownPDF} from "../../components/FeeBreakdownPDF"
import {RateInformationPDF} from "../../components/RateInformationPDF"
import {CapitalizedCostBreakdownPDF} from "../../components/CapitalizedCostBreakdownPDF"
import {MileageInformationPDF} from "../../components/MileageInformationPDF"
import {ProfitInformationPDF} from "../../components/ProfitInformationPDF"
import {ResidualInformationPDF} from "../../components/ResidualInformationPDF"
import {TradeInformationPDF} from "../../components/TradeInformationPDF"
import {DealerVehicleInfoPDF} from "../../components/DealerVehicleInfoPDF"
import {HeaderPDF} from "../../components/HeaderPDF"
import {RebatesBreakdownPDF} from "../../components/RebatesBreakdownPDF"
import {FooterPDF} from "../../components/FooterPDF"
import {BasePDF} from "../../BasePDF"
import {buildPdfFileName} from "../../pdfFileName"

export const DealerDisclosurePDF = ({companyName, dealState, ...props}) => (
    <BasePDF dealState={dealState} {...props}>
        <Document title={buildPdfFileName(dealState, 'Dealer')}>
            <Page size="A4" style={baseStyles.page} wrap={false}>
                <View style={baseStyles.container}>
                    <HeaderPDF pdfName="Dealer Worksheet" companyName={companyName}/>
                    <DealerVehicleInfoPDF/>

                    <View style={baseStyles.mainGrid}>
                        <View style={[baseStyles.column, baseStyles.columnLeft]}>
                            <AmountDueAtSigningPDF isDealerDisclosure/>
                            <PaymentInformationPDF/>
                            <RateInformationPDF/>
                            <ProfitInformationPDF/>
                            <TradeInformationPDF />
                            <TaxInformationPDF/>
                        </View>

                        <View style={[baseStyles.column, baseStyles.columnRight]}>
                            <CapitalizedCostBreakdownPDF/>
                            <ResidualInformationPDF isDealerDisclosure/>
                            <MileageInformationPDF isDealerDisclosure/>
                            <RebatesBreakdownPDF/>
                            <FeeBreakdownPDF/>
                        </View>
                    </View>

                    <FooterPDF showCompanyLogo/>
                </View>
            </Page>
        </Document>
    </BasePDF>
)
